

import {Injectable, Inject} from 'ng-metadata/core';
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
import {RtaService} from '../../../search/rta.service';
import {FullViewService} from '../fullView.service';
import {getDefaultScope, getVid, isGTISearch} from '../../../appConfig/appConfigForward';
import {PrimoResponse} from '../../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {updateZoteroPlugin} from '../../../nddUtils/zoteroUtil';
import {SearchUtil} from "../../../nddUtils/searchUtil.service";
import {AuthoritySearchService} from "../../authority/authoritySearch.service";

const _get = require('lodash/get');


@Injectable()
export class FullViewPageService {
    private GET_ITEM_API_URL:string;
    private _currentItem: PrimoResponse.IDoc;
    private getItemInProgress: boolean;
    private vid:string= getVid();

    constructor(@Inject('$http') private $http:ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs,
                private configurationUtil: ConfigurationUtil,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
				private fullViewService: FullViewService,
                private authoritySearchService: AuthoritySearchService,
                private rtaService: RtaService,
                private searchUtil: SearchUtil,
                @Inject('$q') private $q){
        this.GET_ITEM_API_URL= restBaseURLs.pnxBaseURL;
    }

    public getItemById(id, mmsid, inst, context, search_scope, adaptor, isFrbr, showPnx,virtualBrowse, searchCDI = false) {
        //---------------------------------Do not touch the following line!!!!-------------------------------------------------------
        this._currentItem= undefined; //Important!!!!!!! this is done so that one time binding is updated once we get the new item
        //---------------------------------------------------------------------------------------------------------------------------
        window.appPerformance.timeStamps["full view api send"] = Date.now();
        search_scope = this.searchUtil.getValidScope(search_scope) || this.searchUtil.getScopeFromTab() || this.searchUtil.getDeepLinkJournalSearchScope();
        let url = this.createUrl(context, id, mmsid, inst, search_scope, adaptor, isFrbr, showPnx,virtualBrowse, searchCDI);
        let promise;
        if(this.configurationUtil.isSuprima() && (adaptor === 'EbscoLocal' || adaptor==='SearchWebhook' || adaptor==='WEBHOOK' || adaptor === 'WorldCatLocal')){
           let docStr= sessionStorage['current_pnx'];
            if(docStr){
                let doc  = JSON.parse(docStr);
                let recordId : string = _get(doc, 'pnx.control.recordid[0]', '');
                if (recordId.indexOf(id) > -1) {
                    let deferred = this.$q.defer();
                    deferred.resolve({data:doc});
                    promise = deferred.promise;
                }
           }
        }

        if(!promise){
            promise = this.$http.get(url); //TODO: this should not be hard coded
        }
        promise.then(
            (response:{data:PrimoResponse.IDoc }) => {
                updateZoteroPlugin(); //send event so that zotero plugin identifies new results
                let doc: PrimoResponse.IDoc = response.data;
                // for availability line
            //    if (doc.delivery) {
            //        if (doc.delivery.availability.length > 1) {
            //            doc.delivery.availability.reverse();
            //        }
            //        if (doc.delivery.deliveryCategory.length > 1) {
            //            doc.delivery.deliveryCategory.reverse();
            //        }
            //        if (doc.delivery.availabilityLinks && doc.delivery.availabilityLinks.length > 1) {
            //            doc.delivery.availabilityLinks.reverse();
            //        }
            //        if (doc.delivery.availabilityLinksUrl && doc.delivery.availabilityLinksUrl.length > 1) {
            //            doc.delivery.availabilityLinksUrl.reverse();
            //        }
            //        if (doc.delivery.serviceMode && doc.delivery.serviceMode.length > 1) {
            //            doc.delivery.serviceMode.reverse();
            //        }

            //        this.fullViewService.updateServices(doc);
            //    }

                this._currentItem= doc;
                return doc;
            }, (error) => {
                console.log('Promize get DOC failed: ' );
                console.log(error);
                 let emptyResult : PrimoResponse.IDoc  = {
                    docs:[],
                    info:{
                        first: '1',
                        last: '0',
                        total: '0',
                        errorDetails: {errorMessage: error.data.errorMessage }
                    }          
                };
                this._currentItem= emptyResult ;
            });
        return promise;
    }

    public createUrl(context, id, mmsid, inst, search_scope, adaptor, isFrbr, showPnx,virtualBrowse, searchCDI) {
        if (context === 'WorldCat') {
            context = 'U';
        }

        if (!id && mmsid) {
            if (this.configurationUtil.isSuprima()) {
                mmsid = 'alma'+mmsid;
            } else {
            context = 'LC'; //Library Card
       	    }
        }
        
        let url = this.GET_ITEM_API_URL + '/' + context + '/' + escape((id ? id : mmsid)) + '?vid=' +
            this.vid + '&lang=' + this.$translate.use();

        if (search_scope) {
            url = url + '&search_scope=' + search_scope;
        }
        if (adaptor) {
            url = url + '&adaptor=' + adaptor;
        }
        if (isFrbr && search_scope) {
            url = url + '&isFrbr=true';
        }
        if (showPnx) {
            url = url + '&showPnx=true';
        }
        if (searchCDI){
            url = url + '&searchCDI=' + searchCDI;
        }

        if (this.authoritySearchService.isAuthorityState()){
            url = url + '&authfulldisplay=true';
        }

        if(isGTISearch()) {
        	url = url + '&rapido=true';
        }
        if (virtualBrowse) {
            url = url + '&virtualBrowse=true';
        }
        if (context === 'LC' && inst) { 
            url = url + '&inst='+inst; 
        }  
        return url;
    }

    get currentItem(){
        return this._currentItem;
    }

    set currentItem(item){
        this._currentItem = item;
    }


    public setGetItemInProgress(value){
        this.getItemInProgress = value;
    }

    public isGetItemInProgress(){
        return this.getItemInProgress;
    }


}
//put here all angular1 modules the service is using
export default [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/fullViewPage/fullViewPage.service.ts